/**
 * TripFuturePlaceholders — "Coming soon" tiles for the future
 * enhancement roadmap: weather, flights, packing, AI tips. Rendered as
 * disabled cards so users see what's coming without breaking navigation.
 * Each becomes a real section by swapping this placeholder tile for a
 * new sibling component in TripDetailsPage.jsx `SECTIONS`.
 */
import { Cloud, Plane, ListChecks, Sparkles } from "lucide-react";

const TILES = [
  { icon: Cloud, label: "Live weather", subtitle: "Destination forecast on the day" },
  { icon: Plane, label: "Flights", subtitle: "Add flight numbers & boarding" },
  { icon: ListChecks, label: "Packing list", subtitle: "Track what you've packed" },
  { icon: Sparkles, label: "AI travel tips", subtitle: "Personalised suggestions" },
];

export default function TripFuturePlaceholders() {
  return (
    <div className="rounded-2xl bg-card border border-border p-5" data-testid="trip-future-section">
      <p className="text-xs uppercase tracking-widest text-muted-foreground mb-3">Coming soon</p>
      <div className="grid grid-cols-2 gap-2">
        {TILES.map((t) => (
          <div key={t.label} className="rounded-xl border border-dashed border-border/70 p-3 opacity-60">
            <t.icon className="w-4 h-4 text-primary mb-2" />
            <p className="text-sm font-medium text-foreground leading-tight">{t.label}</p>
            <p className="text-[11px] text-muted-foreground leading-snug">{t.subtitle}</p>
          </div>
        ))}
      </div>
    </div>
  );
}
